import { AGENCY_LISTING_INIT_LOADING, AGENCY_LISTING_INIT_SUCCESS, AGENCY_LISTING_INIT_FAIL } from '@/store/types'

export const list = {
  [AGENCY_LISTING_INIT_LOADING](state) {
    state.listing.init = 0
    state.listing.initErr = []
    state.listing.menu = {}
  },
  [AGENCY_LISTING_INIT_SUCCESS](state, data) {
    state.listing.init = 1
    state.listing.initErr = []
    state.listing.menu = data.menu
  },
  [AGENCY_LISTING_INIT_FAIL](state, error) {
    state.listing.init = 2
    state.listing.initErr = error
    state.listing.menu = {}
  }
}
